import React from "react";
import { Box, Typography, TextField } from "@mui/material";

const OrganizationStep = ({ organizationInfo, handleInputChange, errors }) => (
    <Box sx={{ mt: 2 }}>
        <Typography variant="h6">Enter Organization Information</Typography>
        <TextField
            label="Organization Name"
            name="name"
            value={organizationInfo.name}
            onChange={handleInputChange}
            error={!!errors?.name}
            helperText={errors?.name}
            fullWidth
            margin="normal"
            required
        />
        <TextField
            label="Address"
            name="address"
            value={organizationInfo.address}
            onChange={handleInputChange}
            error={!!errors?.address}
            helperText={errors?.address}
            fullWidth
            margin="normal"
            required
        />
        <TextField
            label="Chamber of Commerce Number"
            name="chamberOfCommerceNumber"
            value={organizationInfo.chamberOfCommerceNumber}
            onChange={handleInputChange}
            error={!!errors?.chamberOfCommerceNumber}
            helperText={errors?.chamberOfCommerceNumber}
            fullWidth
            margin="normal"
            required
        />
        <TextField
            label="Contact Person"
            name="contact"
            value={organizationInfo.contact}
            onChange={handleInputChange}
            error={!!errors?.contact}
            helperText={errors?.contact}
            fullWidth
            margin="normal"
            required
        />
        <TextField
            label="Email"
            name="email"
            value={organizationInfo.email}
            onChange={handleInputChange}
            error={!!errors?.email}
            helperText={errors?.email}
            fullWidth
            margin="normal"
            required
            type="email"
        />
    </Box>
);

export default OrganizationStep;